import * as React from 'react';
import { BottomFloat } from '../../components/LandingPageV2/BottomFloat';
import { Header } from '../../components/LandingPageV2/Header';
import { LandingPageLayout } from '../../components/LandingPageV2/LandingPageLayout';
import { AdvantagesContainer } from '../AdvantagesContainer';
import { ContactsControls } from '../ContactsControls';
import { HowItWorksContainer } from '../HowItWorksContainer';
import { QuestionsAndAnswersContainer } from '../QuestionsAndAnswersContainer';

export const LandingPageV2Container: React.FC = () => {
  return (
    <div data-testid="landingPageV2">
      <Header controls={<ContactsControls />} />
      <LandingPageLayout>
        <AdvantagesContainer />
        <HowItWorksContainer />
        {/* <FormContainer /> */}
        <QuestionsAndAnswersContainer />
      </LandingPageLayout>
      <BottomFloat>
        <ContactsControls />
      </BottomFloat>
    </div>
  );
};
